import React, { useState } from 'react';
import styled from '@emotion/styled';
import { colors, device } from './GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Button } from './StyledComponents';
import rectangle from '../../images/svgs/mask-slant.svg';
import girl from '../../images/homepage.jpg';
import { css, cx } from '@emotion/css';

const StyledVip = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4em 1em;
    .form-item {
        position: relative;
    }
    form {
        display: flex;
        flex-direction: column;

        button {
            margin: 1em auto 0em;
        }
    }
    .icon {
        top: 1.2em;
        left: 0.7em;

        position: absolute;
    }
    .mobile {
        left: 1em;
        min-height: 28px;
    }

    h4 {
        text-align: center;
        font-size: 32px;
        line-height: 44.8px;
        color: ${colors.white};
    }
    input {
        color: ${colors.white};
        text-indent: 50px;
        border: none;
        padding: 1.5em 1em;
        width: 300px;
        margin: 0.5em 0em;
        background: #3198f7;
    }
    p {
        margin: 1em 0em;
        text-align: center;
        color: ${colors.white};
    }
    background: ${colors.blue};
    @media ${device.tablet} {
        .half {
            width: 300px;
        }
        .full {
            width: 100%;
        }
        .bigger-flex {
            width: 615px;
            display: flex;
        }
        .second {
            margin-right: 1em;
        }
        h4 {
            font-size: 60px;
            line-height: 84px;
        }
    }
`;
interface Props {
    vip?: boolean;
}

export const Vip: React.FC<Props> = ({ vip }) => {
    const [submitState, setSubmitState] = useState<string>();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSubmit = async (e: any) => {
        e.preventDefault();
        setSubmitState('submitting');

        const formData = new FormData(e.target);
        const data = [...formData.keys()].reduce((obj, key) => {
            const value = formData.getAll(key).join(', ').trim();
            if (value) {
                obj[key] = value;
            }
            return obj;
        }, {} as Record<string, unknown>);

        await fetch(`https://api.${window.location.host}/contact`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        setSubmitState('submitted');

        e.target.reset();
    };
    return (
        <StyledVip>
            <h4>Join our Smile Craft VIP list today!</h4>
            {!vip ? (
                <p>
                    Benefits include: Priority Booking, Free SmileCraft Gear, Special offers and
                    discounts
                </p>
            ) : (
                <div className="margin"></div>
            )}
            <form onSubmit={onSubmit}>
                <div className="form-item">
                    <StaticImage
                        className="icon"
                        src="../../images/svgs/avatar-white.svg"
                        placeholder="none"
                        alt="avatar icon"
                    />
                    <input
                        required
                        className="full"
                        placeholder="Enter your Full Name"
                        name="vipName"
                        type="text"
                        id="vipName"
                    />
                </div>
                <div className="bigger-flex">
                    <div className="second form-item">
                        <StaticImage
                            className="icon"
                            src="../../images/svgs/mail-white.svg"
                            placeholder="none"
                            alt="mail icon"
                        />
                        <input
                            required
                            className="half"
                            placeholder="Enter your e-mail address"
                            name="vipEmail"
                            type="text"
                            id="vipEmail"
                        />
                    </div>
                    <div className="half form-item">
                        <StaticImage
                            className=" mobile icon"
                            src="../../images/svgs/mobile-white.svg"
                            placeholder="none"
                            alt="mobile icon"
                        />
                        <input
                            required
                            className="half"
                            placeholder="Enter your Phone Number"
                            name="vipPhone"
                            type="tel"
                            id="vipPhone"
                        />
                    </div>
                </div>

                {submitState === 'submitted' ? (
                    <>
                        <Button
                            disabled
                            color="blue"
                            style={{ cursor: 'auto', color: `${colors.white}` }}
                        >
                            Message Recieved!
                        </Button>
                    </>
                ) : (
                    <Button color="white" type="submit">
                        {submitState === 'submitting' ? 'sending...' : 'JOIN THE LIST!'}
                    </Button>
                )}
            </form>
        </StyledVip>
    );
};
